export const accordionKeys = {
    overview: 'overview',
    images: 'images',
    raw: 'raw',
    silos: 'silos',
    threeDModel: 'threeDModel',
    lifestyle: 'lifestyle',
    data: 'data',
    productInformaton: 'productInformation',
    descriptions: 'descriptions',
    additionalFeatures: 'additionalFeatures',
} as const;

type SubTab = {
    key: string;
    label: string;
    show?: (data: Record<string, any>) => boolean;
};

type Tab = {
    key: string;
    label: string;
    show: (productData: Record<string, any>) => boolean;
    children?: SubTab[];
};

export const tabConfig: Tab[] = [
    { key: accordionKeys.overview, label: "Overview", show: () => true },
    {
        key: accordionKeys.images,
        label: "Images",
        show: () => true,
        children: [
            { key: accordionKeys.raw, label: "Raw", show: () => true, },
            { key: accordionKeys.silos, label: "Silos", show: () => true, },
            { key: accordionKeys.threeDModel, label: "3D Model", show: () => true, },
            { key: accordionKeys.lifestyle, label: "Lifestyle", show: () => true, },
        ]
    },
    {
        key: accordionKeys.data,
        label: "Data",
        show: () => true,
        children: [] // Children will be populated dynamically
    }
];
